module.exports = __webpack_public_path__ + "static/two-947e050000d30c360ec46165b9f952eb.png";